export default __webpack_public_path__ + "static/media/Punto_01_Porto_Mediceo_SPA_Def.2e566d37.aac";